(function () {
  var sectionSelector = '[data-product-reviews]';
  var initializedKey = 'productReviewsInitialized';
  var modalOpenClass = 'lx-product-reviews-modal-open';

  function getCards(root) {
    return Array.prototype.slice.call(root.querySelectorAll('[data-product-review-card]'));
  }

  function getFocusableElements(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, video[controls], iframe, [tabindex]:not([tabindex="-1"])')
    );
  }

  function getModal(root) {
    return root.productReviewModal || root.querySelector('[data-product-review-modal]');
  }

  function pauseCardVideo(card) {
    var player = card.querySelector('[data-product-review-player]');
    var video = card.querySelector('video');
    var iframe = card.querySelector('[data-product-review-iframe]');

    if (video) {
      video.pause();
      video.removeAttribute('controls');
    }

    if (iframe) {
      iframe.removeAttribute('src');
    }

    if (player) {
      player.hidden = true;
    }

    card.classList.remove('is-playing');
  }

  function pauseAllCardVideos(root) {
    getCards(root).forEach(pauseCardVideo);
  }

  function stopModalMedia(modal) {
    if (!modal) {
      return;
    }

    modal.querySelectorAll('video').forEach(function (video) {
      video.pause();
      video.currentTime = 0;
    });

    modal.querySelectorAll('[data-product-review-modal-iframe]').forEach(function (iframe) {
      iframe.removeAttribute('src');
    });
  }

  function closeModal(root) {
    var modal = getModal(root);
    var content = modal ? modal.querySelector('[data-product-review-modal-content]') : null;

    if (!modal || modal.hidden) {
      return;
    }

    stopModalMedia(modal);
    modal.hidden = true;
    document.documentElement.classList.remove(modalOpenClass);
    document.body.classList.remove(modalOpenClass);

    if (content) {
      content.innerHTML = '';
    }

    if (root.productReviewLastFocused && root.productReviewLastFocused.focus) {
      root.productReviewLastFocused.focus({ preventScroll: true });
    }

    root.productReviewLastFocused = null;
  }

  function startModalMedia(modal) {
    var iframe = modal.querySelector('[data-product-review-modal-iframe]');
    var video = modal.querySelector('video');

    if (iframe && iframe.dataset.src) {
      iframe.setAttribute('src', iframe.dataset.src);
      return;
    }

    if (video) {
      var playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {});
      }
    }
  }

  function openModal(root, card) {
    var modal = getModal(root);
    var dialog = modal ? modal.querySelector('.lx-product-reviews-modal__dialog') : null;
    var content = modal ? modal.querySelector('[data-product-review-modal-content]') : null;
    var template = card.querySelector('[data-product-review-modal-template]');

    if (!modal || !dialog || !content || !template) {
      return;
    }

    pauseAllCardVideos(root);
    stopModalMedia(modal);
    content.innerHTML = '';
    content.appendChild(template.content.cloneNode(true));

    root.productReviewLastFocused = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add(modalOpenClass);
    document.body.classList.add(modalOpenClass);
    dialog.focus({ preventScroll: true });
    startModalMedia(modal);
  }

  function bindModal(root) {
    var modal = getModal(root);

    if (!modal) {
      return;
    }

    root.productReviewModal = modal;

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    modal.querySelectorAll('[data-product-review-modal-close]').forEach(function (button) {
      button.addEventListener('click', function () {
        closeModal(root);
      });
    });

    modal.addEventListener('keydown', function (event) {
      var focusable = getFocusableElements(modal).filter(function (element) {
        return element.offsetParent !== null || element === document.activeElement;
      });
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal(root);
        return;
      }

      if (event.key !== 'Tab' || !first || !last) {
        return;
      }

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function bindCards(root) {
    getCards(root).forEach(function (card) {
      var startX = 0;
      var startY = 0;
      var moved = false;

      card.addEventListener('pointerdown', function (event) {
        startX = event.clientX;
        startY = event.clientY;
        moved = false;
      });

      card.addEventListener('pointermove', function (event) {
        if (Math.abs(event.clientX - startX) > 8 || Math.abs(event.clientY - startY) > 8) {
          moved = true;
        }
      });

      card.addEventListener('click', function (event) {
        if (moved) {
          return;
        }

        event.preventDefault();
        openModal(root, card);
      });

      card.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        event.preventDefault();
        openModal(root, card);
      });
    });
  }

  function bindTrackDrag(root) {
    var tracks = Array.prototype.slice.call(root.querySelectorAll('[data-product-review-track]'));

    tracks.forEach(function (track) {
      if (track.dataset.productReviewDragBound === 'true') {
        return;
      }

      var pointerId = null;
      var startX = 0;
      var startY = 0;
      var startScrollLeft = 0;
      var isDragging = false;
      var resetSuppressTimer = null;

      function stopDrag() {
        if (pointerId !== null && track.hasPointerCapture && track.hasPointerCapture(pointerId)) {
          track.releasePointerCapture(pointerId);
        }

        if (isDragging) {
          track.dataset.productReviewSuppressClick = 'true';
          window.clearTimeout(resetSuppressTimer);
          resetSuppressTimer = window.setTimeout(function () {
            delete track.dataset.productReviewSuppressClick;
          }, 350);
        }

        pointerId = null;
        isDragging = false;
        track.classList.remove('is-dragging');
      }

      track.dataset.productReviewDragBound = 'true';

      track.addEventListener('dragstart', function (event) {
        event.preventDefault();
      });

      track.addEventListener(
        'click',
        function (event) {
          if (track.dataset.productReviewSuppressClick !== 'true') {
            return;
          }

          event.preventDefault();
          event.stopImmediatePropagation();
          delete track.dataset.productReviewSuppressClick;
          window.clearTimeout(resetSuppressTimer);
        },
        true
      );

      track.addEventListener('pointerdown', function (event) {
        if (event.pointerType === 'touch' || event.button !== 0 || track.scrollWidth <= track.clientWidth) {
          return;
        }

        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        startScrollLeft = track.scrollLeft;
        isDragging = false;

        if (track.setPointerCapture) {
          track.setPointerCapture(pointerId);
        }
      });

      track.addEventListener('pointermove', function (event) {
        var deltaX;
        var deltaY;

        if (pointerId !== event.pointerId) {
          return;
        }

        deltaX = event.clientX - startX;
        deltaY = event.clientY - startY;

        if (!isDragging) {
          if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) {
            return;
          }

          if (Math.abs(deltaY) > Math.abs(deltaX) * 1.25) {
            stopDrag();
            return;
          }

          isDragging = true;
          track.classList.add('is-dragging');
        }

        event.preventDefault();
        track.scrollLeft = startScrollLeft - deltaX;
      });

      track.addEventListener('pointerup', stopDrag);
      track.addEventListener('pointercancel', stopDrag);
    });
  }

  function initSection(root) {
    if (!root || root.dataset[initializedKey] === 'true') {
      return;
    }

    root.dataset[initializedKey] = 'true';
    bindCards(root);
    bindTrackDrag(root);
    bindModal(root);
  }

  function initAll(scope) {
    var searchScope = scope || document;

    if (searchScope.matches && searchScope.matches(sectionSelector)) {
      initSection(searchScope);
      return;
    }

    searchScope.querySelectorAll(sectionSelector).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var target = event.target;
    var root = target && target.matches && target.matches(sectionSelector)
      ? target
      : target && target.querySelector
        ? target.querySelector(sectionSelector)
        : null;

    if (root) {
      closeModal(root);

      if (root.productReviewModal && root.productReviewModal.parentNode) {
        root.productReviewModal.parentNode.removeChild(root.productReviewModal);
      }

      root.productReviewModal = null;
    }
  });
})();
